// Config
import GIFT_MESSAGE from '@utils/form/configs/giftMessage';
import stripWhitespace from '@utils/string/stripWhitespace';
import { getTextAreaLinesArray } from '@utils/string/textAreaUtils';

export function getGiftMessageLines({ giftReceipt = false, giftMessage = '' }) {
  let giftMessageLines;

  if (giftReceipt) {
    const rawGiftMessage = stripWhitespace(giftMessage);
    const {
      props: { maxLines, maxCharsLine },
    } = GIFT_MESSAGE;
    giftMessageLines = rawGiftMessage
      ? getTextAreaLinesArray({ string: giftMessage, maxLines, maxCharsLine })
      : ['This is a gift receipt'];
  }

  return giftMessageLines;
}

export default getGiftMessageLines;
